import WelcomeModal from "./welcome_modal";
import { hideModal } from "../../../actions/modal";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import head from "lodash/head";
import get from "lodash/get";

function mapStateToProps(state) {
  let showUUID = head(Object.keys(state.shows.shows));
  const show = get(state.shows.shows, showUUID);
  return {
    user: state.user.user,
    show: show,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => {
      dispatch(hideModal());
    },
  };
}

const WelcomeModalWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(WelcomeModal));

export default WelcomeModalWrapper;
